export default __webpack_public_path__ + "static/media/ordrr-logo-wht.388a3112.svg";